const _ = require('./enum');
const FieldTypes = require('./fieldTypes');

/**
 * Fields
 */
module.exports = {
  [_.ACCEPT_URL]: {
    key: _.ACCEPT_URL,
    label: 'Accept URL',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'accept_url',
    description:
      'The accept URL is the URL the customer is redirected to after the payment process has been successfully completed. It can be configured in the "API & Notifications / Redirect URLs" menu.',
  },
  [_.ACCOUNT_BIC]: {
    key: _.ACCOUNT_BIC,
    label: 'Account BIC',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'account_bic',
    description:
      'The account BIC (Bank Identifier Code) is an 8 to 11-character number used to identify a specific bank for bank transfer transactions.',
  },
  [_.ACCOUNT_HOLDER_FIRST_NAME]: {
    key: _.ACCOUNT_HOLDER_FIRST_NAME,
    label: 'Account holder first name',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'account_holder_first_name',
    gdpr: true,
    description: 'The first name of the person listed or identified as the holder of the bank account used for the payment.',
  },
  [_.ACCOUNT_HOLDER_LAST_NAME]: {
    key: _.ACCOUNT_HOLDER_LAST_NAME,
    label: 'Account holder last name',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'account_holder_last_name',
    gdpr: true,
    description: 'The last name of the person listed or identified as the holder of the bank account used for the payment.',
  },
  [_.ACCOUNT_IBAN]: {
    key: _.ACCOUNT_IBAN,
    label: 'Account IBAN',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'account_iban',
    gdpr: true,
    description:
      'The Account IBAN (International Bank Account Number) is a standard international numbering system used to identify a bank account for bank transfer transactions.',
  },
  [_.ACCOUNT_NUMBER]: {
    key: _.ACCOUNT_NUMBER,
    label: 'Account number',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'account_number',
    gdpr: true,
    description:
      'The account number can be the obfuscated card number for card payments, the email, bank account, or payment method identifier for alternative payment methods.',
  },
  [_.ACCOUNT_ROUTING_NUMBER]: {
    key: _.ACCOUNT_ROUTING_NUMBER,
    label: 'Account routing number',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'account_routing_number',
    gdpr: true,
    description: 'For a bank transfer order, it refers to the account routing number (no SEPA) of the account holder.',
  },
  [_.TRANSACTION_AMOUNT]: {
    key: _.TRANSACTION_AMOUNT,
    label: 'Transaction amount',
    type: FieldTypes.AMOUNT,
    entity: 'transactions',
    path: 'amount',
    description: 'The amount of the payment transaction.',
  },
  [_.APM_CODE]: {
    key: _.APM_CODE,
    label: 'APM code',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'apm_code',
    description: 'The APM code of a transaction is the specific id to be send when using an APM.',
  },
  [_.ATTEMPTS_REMAINING]: {
    key: _.ATTEMPTS_REMAINING,
    label: 'Attempts remaining',
    type: FieldTypes.NUMBER,
    entity: 'order',
    path: 'attempts_remaining',
    description: 'The number of remaining payment attempts for an order.',
  },
  [_.AUTHENTICATION_DATE]: {
    key: _.AUTHENTICATION_DATE,
    label: 'Authentication date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'authentication_date',
    description: 'The authentication date of the transaction.',
  },
  [_.AUTHENTICATION_PARTNER]: {
    key: _.AUTHENTICATION_PARTNER,
    label: 'Authentication partner',
    type: FieldTypes.AUTHENTICATION_PARTNER,
    entity: 'order',
    path: 'transactions.authentication_partner_api_name',
    filter: true,
    description: 'The provider in charge of the authentication of the transaction.',
  },
  [_.AUTHENTICATION_REQUEST_DATE]: {
    key: _.AUTHENTICATION_REQUEST_DATE,
    label: 'Authentication request date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'authentication_request_date',
    description: 'The date of the request for authentication of the transaction.',
  },
  [_.AUTHENTICATION_REQUEST_STATUS]: {
    key: _.AUTHENTICATION_REQUEST_STATUS,
    label: 'Authentication request status',
    type: FieldTypes.AUTHENTICATION_REQUEST_STATUS,
    entity: 'transactions',
    path: 'authentication_request_status',
    description:
      'The status of the request for authentication of the transaction. It can be Authentication requested or Authentication request failed.',
  },
  [_.AUTHENTICATION_RESULT]: {
    key: _.AUTHENTICATION_RESULT,
    label: 'Authentication result',
    type: FieldTypes.AUTHENTICATION_RESULT,
    entity: 'transactions',
    path: 'authentication_result',
    filter: true,
    description: 'The authentication result of the transaction. It can be Accepted, Unavailable, Attempted, Pending or Declined.',
  },
  [_.AUTHORIZATION_CODE]: {
    key: _.AUTHORIZATION_CODE,
    label: 'Authorization code',
    type: FieldTypes.AUTHORIZATION_CODE,
    entity: 'transactions',
    path: 'authorization_code',
    description: 'The unique identifier of the authorization (shared between the issuer and the acquirer) for example ARN.',
  },
  [_.AUTHORIZATION_DATE]: {
    key: _.AUTHORIZATION_DATE,
    label: 'Authorization date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'authorization_date',
    filter: true,
    description: 'The authorization date of the transaction.',
  },
  [_.AUTHORIZATION_REQUEST_DATE]: {
    key: _.AUTHORIZATION_REQUEST_DATE,
    label: 'Authorization request date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'authorization_request_date',
    description: 'The date of the request for authorization of the transaction.',
  },
  [_.AUTHORIZATION_REQUEST_STATUS]: {
    key: _.AUTHORIZATION_REQUEST_STATUS,
    label: 'Authorization request status',
    type: FieldTypes.AUTHORIZATION_REQUEST_STATUS,
    entity: 'transactions',
    path: 'authorization_request_status',
    description:
      'The result of the request for authorization of the transaction. It can be Authorization requested, Authorization request failed or Authorization request expired.',
  },
  [_.AUTHORIZATION_RESULT]: {
    key: _.AUTHORIZATION_RESULT,
    label: 'Authorization result',
    type: FieldTypes.STATUS_RESULT,
    entity: 'transactions',
    path: 'authorization_result',
    filter: true,
    description: 'The result of authorization of the transaction. It can be Success, Failure or Pending.',
  },
  [_.AUTHORIZATION_STATUS]: {
    key: _.AUTHORIZATION_STATUS,
    label: 'Authorization status',
    type: FieldTypes.AUTHORIZATION_STATUS,
    entity: 'transactions',
    path: 'authorization_status',
    description:
      'The authorization status of the transaction. It can be Authorization requested, Authorization successful, Authorization declined, Authorization expired.',
  },
  [_.BASKET_TYPE]: {
    key: _.BASKET_TYPE,
    label: 'Basket type',
    type: FieldTypes.BASKET_TYPE,
    entity: 'order',
    path: 'basket_type',
    description: 'The basket type of the order. It can be physical, digital, or mixed.',
  },
  [_.CANCELLATION_DATE]: {
    key: _.CANCELLATION_DATE,
    label: 'Cancellation date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'cancellation_date',
    description: 'The cancellation date of the transaction.',
  },
  [_.CANCELLATION_REQUEST_DATE]: {
    key: _.CANCELLATION_REQUEST_DATE,
    label: 'Cancellation request date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'cancellation_request_date',
    description: 'The date of the request for cancellation of the transaction.',
  },
  [_.CANCELLATION_REQUEST_STATUS]: {
    key: _.CANCELLATION_REQUEST_STATUS,
    label: 'Cancellation request status',
    type: FieldTypes.CANCELLATION_REQUEST_STATUS,
    entity: 'transactions',
    path: 'cancellation_request_status',
    description: 'The status of the request for cancellation of the transaction. It can be Cancellation requested or Cancellation request failed.',
  },
  [_.CANCELLATION_RESULT]: {
    key: _.CANCELLATION_RESULT,
    label: 'Cancellation result',
    type: FieldTypes.STATUS_RESULT,
    entity: 'transactions',
    path: 'cancellation_result',
    description: 'The cancellation result of the transaction. It can be Success, Failure or Pending.',
  },
  [_.CANCELLATION_STATUS]: {
    key: _.CANCELLATION_STATUS,
    label: 'Cancellation status',
    type: FieldTypes.CANCELLATION_STATUS,
    entity: 'transactions',
    path: 'cancellation_status',
    description: 'The cancellation status of the transaction. It can Cancellation requested, Cancellation successful, Cancellation declined.',
  },
  [_.CAPTURED_AMOUNT]: {
    key: _.CAPTURED_AMOUNT,
    label: 'Captured amount',
    type: FieldTypes.AMOUNT,
    entity: 'transactions',
    path: 'captured_amount',
    description: 'The capture amount requested for the transaction.',
  },
  [_.CAPTURE_DATE]: {
    key: _.CAPTURE_DATE,
    label: 'Capture date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'capture_date',
    filter: true,
    description: 'The capture date of the transaction.',
  },
  [_.CAPTURE_REQUEST_DATE]: {
    key: _.CAPTURE_REQUEST_DATE,
    label: 'Capture request date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'capture_request_date',
    description: 'The date of the request for capture of the transaction.',
  },
  [_.CAPTURE_REQUEST_STATUS]: {
    key: _.CAPTURE_REQUEST_STATUS,
    label: 'Capture request status',
    type: FieldTypes.CAPTURE_REQUEST_STATUS,
    entity: 'transactions',
    path: 'capture_request_status',
    description: 'The result of the request for capture of the transaction. It can be Capture requested or Capture request failed.',
  },
  [_.CAPTURE_RESULT]: {
    key: _.CAPTURE_RESULT,
    label: 'Capture result',
    type: FieldTypes.STATUS_RESULT,
    entity: 'transactions',
    path: 'capture_result',
    description: 'The capture result for the transaction. It can be success, failure or pending.',
  },
  [_.CAPTURE_STATUS]: {
    key: _.CAPTURE_STATUS,
    label: 'Capture status',
    type: FieldTypes.CAPTURE_STATUS,
    entity: 'transactions',
    path: 'capture_status',
    description: 'The result of capture of the transaction. It can be Success, Failure or Pending.',
  },
  [_.CARD_4_DIGITS]: {
    key: _.CARD_4_DIGITS,
    label: 'Card 4 digits',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'card_4_digits',
    filter: true,
    description: 'The last 4 digits of the card number.',
  },
  [_.CARD_6_DIGITS]: {
    key: _.CARD_6_DIGITS,
    label: 'Card 6 digits',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'card_6_digits',
    filter: true,
    description:
      'The first 6 digits of the card number (BIN). They identify the issuer of the card. This sequence of numbers begins, for example, with a 4 for Visa, a 5 for Mastercard and 3 for American Express.  ',
  },
  [_.CARD_COUNTRY]: {
    key: _.CARD_COUNTRY,
    label: 'Card country',
    type: FieldTypes.COUNTRY,
    entity: 'transactions',
    path: 'card_country',
    filter: true,
    description: 'The country of the issuer of the card used for the payment. In text mode, it appears as a 2-letter ISO country code.',
  },
  [_.CARD_ENROLLED]: {
    key: _.CARD_ENROLLED,
    label: 'Card enrolled',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'card_enrolled',
    description: 'It indicates if the card has been enrolled in the 3-D secure protocol.',
  },
  [_.CARD_ISSUER]: {
    key: _.CARD_ISSUER,
    label: 'Card issuer',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'card_issuer',
    filter: true,
    description:
      'The issuer is the payer’s bank or financial institution that issued the card used by the customer. The issuer represents the customer within the payment schemes (Visa, Mastercard, etc.).',
  },
  [_.CARD_NUMBER]: {
    key: _.CARD_NUMBER,
    label: 'Card number',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'card_number',
    description:
      'The obfuscated card number used for the payment, based on the first 6 digits of the card number (BIN) and the last 4 digits of the card number.',
  },
  [_.CASHIER_FILE_DATE]: {
    key: _.CASHIER_FILE_DATE,
    label: 'Cashier file date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'pos_file_date',
    filter: true,
    description: 'An cashier file represents a group of transactions received from a cashier partner.',
  },
  [_.CASHIER_FILE_ID]: {
    key: _.CASHIER_FILE_ID,
    label: 'Cashier file ID',
    type: FieldTypes.ID,
    entity: 'order',
    path: 'transactions.pos_file_id',
    filter: true,
    description: 'An cashier file represents a group of transactions received from a cashier partner.',
  },
  [_.CASHIER_FILE_NAME]: {
    key: _.CASHIER_FILE_NAME,
    label: 'Cashier file name',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'pos_file_name',
    filter: true,
    description: 'An cashier file represents a group of transactions received from a cashier partner.',
  },
  [_.CASHIER_PARTNER]: {
    key: _.CASHIER_PARTNER,
    label: 'Cashier partner',
    type: FieldTypes.CASHIER_PARTNER,
    entity: 'order',
    path: 'transactions.cashier_partner_api_name',
    filter: true,
    description: 'The cashier provider who handled the creation of the transaction.',
  },
  [_.CATEGORY]: {
    key: _.CATEGORY,
    label: 'Category',
    type: FieldTypes.CATEGORY,
    entity: 'order',
    path: 'category',
    filter: true,
    description: 'The category of order, Payin or Payout.',
  },
  [_.CHALLENGE_PREFERENCE]: {
    key: _.CHALLENGE_PREFERENCE,
    label: 'Challenge preference',
    type: FieldTypes.CHALLENGE_PREFERENCE,
    entity: 'transactions',
    path: 'challenge_preference',
    filter: true,
    description: 'The challenge preference applied for the payment transaction.',
  },
  [_.CHARGEBACK_AMOUNT]: {
    key: _.CHARGEBACK_AMOUNT,
    label: 'Chargeback amount',
    type: FieldTypes.AMOUNT,
    entity: 'transactions',
    path: 'chargeback_amount',
    description: 'The total amount charged back for the transaction.',
  },
  [_.CHARGEBACK_DATE]: {
    key: _.CHARGEBACK_DATE,
    label: 'Chargeback date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'chargeback_date',
    filter: true,
    description: 'The chargeback date of the transaction.',
  },
  [_.CHARGEBACK_REASON]: {
    key: _.CHARGEBACK_REASON,
    label: 'Chargeback reason',
    type: FieldTypes.CHARGEBACK_REASON,
    entity: 'transactions',
    path: 'chargeback_reason',
    filter: true,
    description:
      'A chargeback is the return of credit card funds for an order. It can occur if a consumer disputes a purchase placed without their knowledge or permission. This field describes the reason for the chargeback provided by the acquirer.',
  },
  [_.CHARGEBACK_REASON_CODE]: {
    key: _.CHARGEBACK_REASON_CODE,
    label: 'Chargeback reason code',
    type: FieldTypes.CHARGEBACK_REASON_CODE,
    entity: 'transactions',
    path: 'chargeback_reason_code',
    description: 'The chargeback reason code is the identifier provided by the acquirer to describe the reason of the chargeback.',
  },
  [_.TRANSACTION_CREATION_DATE]: {
    key: _.TRANSACTION_CREATION_DATE,
    label: 'Transaction creation date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'createdAt',
    filter: true,
    description: 'The creation date of the transaction.',
  },
  [_.CMS_NAME]: {
    key: _.CMS_NAME,
    label: 'CMS',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'merchant_account.cms_name',
    filter: true,
    description: 'The name of the CMS (content management system) used on the merchant account.',
  },
  [_.CMS_VERSION]: {
    key: _.CMS_VERSION,
    label: 'CMS version',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'merchant_account.cms_version',
    filter: true,
    description: 'The version of the CMS (content management system) used on the merchant account.',
  },
  [_.CURRENCY]: {
    key: _.CURRENCY,
    label: 'Currency',
    type: FieldTypes.CURRENCY,
    entity: 'order',
    path: 'currency',
    filter: true,
    description: 'The currency used for the authorization of the transaction. Required, it uses the 3-letter ISO currency code.',
  },
  [_.CUSTOMER_ACCOUNT_CHANGE_DATE]: {
    key: _.CUSTOMER_ACCOUNT_CHANGE_DATE,
    label: 'Customer account change date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'customer_account_change_date',
    description: 'The last update date of the customer account on the merchant website.',
  },
  [_.CUSTOMER_ACCOUNT_CREATION_DATE]: {
    key: _.CUSTOMER_ACCOUNT_CREATION_DATE,
    label: 'Customer account creation date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'customer_account_creation_date',
    description: 'The date of the creation of the customer account on the merchant website.',
  },
  [_.CUSTOMER_ACCOUNT_LOGIN_TYPE]: {
    key: _.CUSTOMER_ACCOUNT_LOGIN_TYPE,
    label: 'Customer account login type',
    type: FieldTypes.CUSTOMER_ACCOUNT_LOGIN_TYPE,
    entity: 'transactions',
    path: 'customer_account_login_type',
    description: 'The login type of the customer account on the merchant website.',
  },
  [_.CUSTOMER_BILLING_CITY]: {
    key: _.CUSTOMER_BILLING_CITY,
    label: 'Customer billing city',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_billing_city',
    description: 'The city on the billing address.',
  },
  [_.CUSTOMER_BILLING_COUNTRY]: {
    key: _.CUSTOMER_BILLING_COUNTRY,
    label: 'Customer billing country',
    type: FieldTypes.COUNTRY,
    entity: 'transactions',
    path: 'customer_billing_country',
    description: 'The country on the billing address. In text mode, it uses the 2-letter ISO country code.',
  },
  [_.CUSTOMER_BILLING_FIRST_NAME]: {
    key: _.CUSTOMER_BILLING_FIRST_NAME,
    label: 'Customer billing first name',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_billing_first_name',
    gdpr: true,
    description: 'The first name of the customer on the billing address.',
  },
  [_.CUSTOMER_BILLING_LAST_NAME]: {
    key: _.CUSTOMER_BILLING_LAST_NAME,
    label: 'Customer billing last name',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_billing_last_name',
    gdpr: true,
    description: 'The last name of the customer on the billing address.',
  },
  [_.CUSTOMER_BILLING_STREET_NAME]: {
    key: _.CUSTOMER_BILLING_STREET_NAME,
    label: 'Customer billing street name',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_billing_street_name',
    gdpr: true,
    description: 'The street name on the billing address.',
  },
  [_.CUSTOMER_BILLING_ZIP_CODE]: {
    key: _.CUSTOMER_BILLING_ZIP_CODE,
    label: 'Customer billing zip code',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_billing_zip_code',
    gdpr: true,
    description: "The customer's ZIP code on the billing. It's the ZIP code of the customer registered on the billing at order time.",
  },
  [_.CUSTOMER_BIRTH_DATE]: {
    key: _.CUSTOMER_BIRTH_DATE,
    label: 'Customer birth date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'customer_birth_date',
    gdpr: true,
    description: "The customer's birth date.",
  },
  [_.CUSTOMER_CITY]: {
    key: _.CUSTOMER_CITY,
    label: 'Customer city',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_city',
    description: "The customer's city.",
  },
  [_.CUSTOMER_COUNTRY]: {
    key: _.CUSTOMER_COUNTRY,
    label: 'Customer country',
    type: FieldTypes.COUNTRY,
    entity: 'order',
    path: 'transactions.customer_country',
    filter: true,
    description: "The customer's country. In text mode, it uses the 2-letter ISO country code.",
  },
  [_.CUSTOMER_EMAIL]: {
    key: _.CUSTOMER_EMAIL,
    label: 'Customer email',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'transactions.customer_email',
    filter: true,
    gdpr: true,
    description: "The customer's email.",
  },
  [_.CUSTOMER_FIRST_NAME]: {
    key: _.CUSTOMER_FIRST_NAME,
    label: 'Customer first name',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_first_name',
    filter: true,
    gdpr: true,
    description: "The customer's first name",
  },
  [_.CUSTOMER_ID]: {
    key: _.CUSTOMER_ID,
    label: 'Customer ID',
    type: FieldTypes.ID,
    entity: 'transactions',
    path: 'customer_id',
    description: "The customer's unique identifier on the merchant's website.",
  },
  [_.CUSTOMER_IP]: {
    key: _.CUSTOMER_IP,
    label: 'Customer IP',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_ip',
    filter: true,
    gdpr: true,
    description: "The customer's IP address.",
  },
  [_.CUSTOMER_IP_COUNTRY]: {
    key: _.CUSTOMER_IP_COUNTRY,
    label: 'Customer IP country',
    type: FieldTypes.COUNTRY,
    entity: 'transactions',
    path: 'customer_ip_country',
    description: "The customer's IP country. In text mode, it uses the 2-letter ISO country code.",
  },
  [_.CUSTOMER_LAST_NAME]: {
    key: _.CUSTOMER_LAST_NAME,
    label: 'Customer last name',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_last_name',
    filter: true,
    gdpr: true,
    description: "The customer's last name.",
  },
  [_.CUSTOMER_PHONE_NUMBER]: {
    key: _.CUSTOMER_PHONE_NUMBER,
    label: 'Customer phone number',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_phone_number',
    gdpr: true,
    description: "The customer's phone number.",
  },
  [_.CUSTOMER_PHONE_NUMBER_TYPE]: {
    key: _.CUSTOMER_PHONE_NUMBER_TYPE,
    label: 'Customer phone number type',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_phone_number_type',
    gdpr: true,
    description: "The customer's phone number type.",
  },
  [_.CUSTOMER_STREET_NAME]: {
    key: _.CUSTOMER_STREET_NAME,
    label: 'Customer street name',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_street_name',
    gdpr: true,
    description: "The customer's street.",
  },
  [_.CUSTOMER_ZIP_CODE]: {
    key: _.CUSTOMER_ZIP_CODE,
    label: 'Customer zip code',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_zip_code',
    filter: true,
    gdpr: true,
    description: "The customer's ZIP code.",
  },
  [_.DECLINE_URL]: {
    key: _.DECLINE_URL,
    label: 'Decline URL',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'decline_url',
    description:
      "The decline URL is the URL the customer is redirected to after the payment is declined. It can be configured in the 'API & Notifications / Redirect URLs' menu.",
  },
  [_.DEVICE_TYPE]: {
    key: _.DEVICE_TYPE,
    label: 'Device type',
    type: FieldTypes.DEVICE_TYPE,
    entity: 'transactions',
    path: 'device_type',
    filter: true,
    description: 'The device type used by the customer for the order.',
  },
  [_.EXCEPTION_URL]: {
    key: _.EXCEPTION_URL,
    label: 'Exception URL',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'exception_url',
    description:
      "The exception URL is the URL the customer is redirected to after a system failure. It can be configured in the 'API & Notifications / Redirect URLs' menu.",
  },
  [_.GIFTCARD_AMOUNT]: {
    key: _.GIFTCARD_AMOUNT,
    label: 'Giftcard amount',
    type: FieldTypes.AMOUNT,
    entity: 'order',
    path: 'giftcard_amount',
    description: 'The total amount of the gift card(s) used for the payment.',
  },
  [_.GIFTCARD_CURRENCY]: {
    key: _.GIFTCARD_CURRENCY,
    label: 'Giftcard currency',
    type: FieldTypes.CURRENCY,
    entity: 'order',
    path: 'giftcard_currency',
    description: 'The currency used to pay with one or more gift cards.',
  },
  [_.GIFTCARD_NUMBER]: {
    key: _.GIFTCARD_NUMBER,
    label: 'Giftcard number',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'giftcard_number',
    description: 'The gift cards number used for the payment.',
  },
  [_.GIFTCARD_USED]: {
    key: _.GIFTCARD_USED,
    label: 'Giftcard used',
    type: FieldTypes.BOOLEAN,
    entity: 'order',
    path: 'giftcard_used',
    description: 'Indicates if a gift card was used for the payment.',
  },
  [_.HOLDER]: {
    key: _.HOLDER,
    label: 'Holder',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'token.holder',
    gdpr: true,
    description: 'Name of the holder of the card.',
  },
  [_.INTEGRATION_TYPE]: {
    key: _.INTEGRATION_TYPE,
    label: 'Integration type',
    type: FieldTypes.INTEGRATION_TYPE,
    entity: 'order',
    path: 'merchant_account.integration_type',
    filter: true,
    description: 'The type of integration on the merchant account.',
  },
  [_.IS_AUTHENTICATED]: {
    key: _.IS_AUTHENTICATED,
    label: 'Authenticated',
    type: FieldTypes.BOOLEAN,
    entity: 'transactions',
    path: 'is_authenticated',
    filter: true,
    description: 'Indicates if the transaction is authenticated.',
  },
  [_.IS_AUTHORIZED]: {
    key: _.IS_AUTHORIZED,
    label: 'Authorized',
    type: FieldTypes.BOOLEAN,
    entity: 'transactions',
    path: 'is_authorized',
    filter: true,
    description: 'Indicates if the transaction is authorized.',
  },
  [_.IS_CANCELLED]: {
    key: _.IS_CANCELLED,
    label: 'Cancelled',
    type: FieldTypes.BOOLEAN,
    entity: 'transactions',
    path: 'is_cancelled',
    filter: true,
    description: 'Indicates if the transaction is cancelled.',
  },
  [_.IS_CAPTURED]: {
    key: _.IS_CAPTURED,
    label: 'Captured',
    type: FieldTypes.BOOLEAN,
    entity: 'transactions',
    path: 'is_captured',
    filter: true,
    description: 'Indicates if the transaction is captured.',
  },
  [_.IS_CHARGEBACKED]: {
    key: _.IS_CHARGEBACKED,
    label: 'Charged back',
    type: FieldTypes.BOOLEAN,
    entity: 'transactions',
    path: 'is_chargebacked',
    filter: true,
    description: 'Indicates if the transaction is charged back.',
  },
  [_.IS_CUSTOMER_REGISTERED]: {
    key: _.IS_CUSTOMER_REGISTERED,
    label: 'Is customer registered',
    type: FieldTypes.BOOLEAN,
    entity: 'order',
    path: 'is_customer_registered',
    description: 'Indicates if the customer has an account on the merchant website.',
  },
  [_.IS_FALLBACK]: {
    key: _.IS_FALLBACK,
    label: 'Is fallback',
    type: FieldTypes.BOOLEAN,
    entity: 'transactions',
    path: 'is_fallback',
    description: 'Indicates if the transaction is a fallback.',
  },
  [_.IS_NEW_TRANSACTION]: {
    key: _.IS_NEW_TRANSACTION,
    label: 'Is new transaction',
    type: FieldTypes.BOOLEAN,
    entity: 'transactions',
    path: 'is_new_transaction',
    description: 'Indicates if the transaction is the result of a new payment.',
  },
  [_.IS_ORDER_LAST_TRANSACTION]: {
    key: _.IS_ORDER_LAST_TRANSACTION,
    label: 'Is order last transaction',
    type: FieldTypes.BOOLEAN,
    entity: 'transactions',
    path: 'is_order_last_transaction',
    description: 'Indicates it the transaction is the last for the order.',
  },
  [_.IS_REFUNDED]: {
    key: _.IS_REFUNDED,
    label: 'Refunded',
    type: FieldTypes.BOOLEAN,
    entity: 'transactions',
    path: 'is_refunded',
    filter: true,
    description: 'Indicates if the transaction is refunded.',
  },
  [_.IS_RETURN_ACCEPTED]: {
    key: _.IS_RETURN_ACCEPTED,
    label: 'Return accepted',
    type: FieldTypes.BOOLEAN,
    entity: 'order',
    path: 'is_return_accepted',
    description: 'Indicates if returns are accepted for the order.',
  },
  [_.LIABILITY_SHIFT]: {
    key: _.LIABILITY_SHIFT,
    label: 'Liability shift',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'liability_shift',
    description:
      'Indicates the liable party for the payment transaction. Depending on the authentication process, responsibility for fraudulent chargebacks may shift from the merchant to the issuing bank.',
  },
  [_.MAX_ATTEMPTS]: {
    key: _.MAX_ATTEMPTS,
    label: 'Max attempts',
    type: FieldTypes.NUMBER,
    entity: 'order',
    path: 'max_attempts',
    description: 'The maximum number of attempts for the order, including updates and fallbacks.',
  },
  [_.MERCHANT_ACCOUNT]: {
    key: _.MERCHANT_ACCOUNT,
    label: 'Merchant account',
    type: FieldTypes.MERCHANT_ACCOUNT,
    entity: 'order',
    path: 'merchant_account._id',
    filter: true,
    filterLabel: 'Merchant account',
    description: 'The unique identifier of the merchant account used for the transaction.',
  },
  [_.MERCHANT_ACCOUNT_NAME]: {
    key: _.MERCHANT_ACCOUNT_NAME,
    label: 'Merchant account name',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'merchant_account.name',
    description: 'The name of the merchant account used for the transaction.',
  },
  [_.MERCHANT_CONTRACT]: {
    key: _.MERCHANT_CONTRACT,
    label: 'Merchant contract ID',
    type: FieldTypes.MERCHANT_CONTRACT,
    entity: 'transactions',
    path: 'merchant_contract._id',
    filter: true,
    filterLabel: 'Merchant contract',
    description: 'The unique identifier of the merchant contract used for the transaction.',
  },
  [_.MERCHANT_CONTRACT_NAME]: {
    key: _.MERCHANT_CONTRACT_NAME,
    label: 'Merchant contract name',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'merchant_contract.name',
    description: 'The name of the merchant contract used for the transaction.',
  },
  [_.MERCHANT_DATA]: {
    key: _.MERCHANT_DATA,
    label: 'Merchant data',
    type: FieldTypes.MERCHANT_DATA,
    entity: 'order',
    path: 'merchant_data',
    description:
      'Custom field used to store specific data sent by the merchant when the order is created. Each entry respects the format: key, format, value, is_personal_data.',
  },
  [_.MERCHANT_ROUTE]: {
    key: _.MERCHANT_ROUTE,
    label: 'Merchant route',
    type: FieldTypes.ID,
    entity: 'transactions',
    path: 'merchant_route._id',
    description:
      'The identifier of the route used for the transaction. A route is the combination of a sales channel, payment method, authorization currency, settlement currency and payin partner.',
  },
  [_.ORDER_AMOUNT]: {
    key: _.ORDER_AMOUNT,
    label: 'Order amount',
    type: FieldTypes.AMOUNT,
    entity: 'order',
    path: 'amount',
    filter: true,
    description: 'The total amount of the order.',
  },
  [_.ORDER_DESCRIPTION]: {
    key: _.ORDER_DESCRIPTION,
    label: 'Order description',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'order_description',
    description: 'The general description of the order.',
  },
  [_.ORDER_ID]: {
    key: _.ORDER_ID,
    label: 'Order ID',
    type: FieldTypes.OBJECT_ID,
    entity: 'order',
    path: 'order_id',
    filter: true,
    description: 'The unique identifier of the order.',
  },
  [_.ORDER_MERCHANT_ID]: {
    key: _.ORDER_MERCHANT_ID,
    label: 'Merchant reference',
    type: FieldTypes.ID,
    entity: 'order',
    path: 'order_merchant_id',
    filter: true,
    description: 'The identifier of the order in the merchant order management system.',
  },
  [_.ORDER_STATUS]: {
    key: _.ORDER_STATUS,
    label: 'Order status',
    type: FieldTypes.STATUS,
    entity: 'order',
    path: 'status',
    filter: true,
    description: 'The order status is the status of the last transaction of the order.',
  },
  [_.PAYIN_PARTNER]: {
    key: _.PAYIN_PARTNER,
    label: 'Payin partner',
    type: FieldTypes.PAYIN_PARTNER,
    entity: 'order',
    path: 'transactions.payin_partner_api_name',
    filter: true,
    description: 'The provider who handled the payment processing of the transaction.',
  },
  [_.PAYMENT_CHANNEL]: {
    key: _.PAYMENT_CHANNEL,
    label: 'Payment channel',
    type: FieldTypes.PAYMENT_CHANNEL,
    entity: 'order',
    path: 'transactions.payment_channel',
    filter: true,
    description: 'The payment channel of the order.',
  },
  [_.PAYMENT_METHOD]: {
    key: _.PAYMENT_METHOD,
    label: 'Payment method',
    type: FieldTypes.PAYMENT_METHOD,
    entity: 'order',
    path: 'transactions.payment_method_name',
    filter: true,
    description: 'The name of the method payment used by the customer for the payment.',
  },
  [_.PAYMENT_METHOD_TYPE]: {
    key: _.PAYMENT_METHOD_TYPE,
    label: 'Payment method type',
    type: FieldTypes.PAYMENT_METHOD_TYPE,
    entity: 'transactions',
    path: 'payment_method_type',
    filter: true,
    description: 'The type of method payment used by the customer for the payment. (e.g. card, bank transfer, invoice, etc.)',
  },
  [_.PENDING_URL]: {
    key: _.PENDING_URL,
    label: 'Pending URL',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'pending_url',
    description:
      "The pending URL is the URL the customer is redirected to when the payment request was processed but the response is not yet available. It can be configured in the 'API & Notifications / Redirect URLs' menu.",
  },
  [_.PLAN_ID]: {
    key: _.PLAN_ID,
    label: 'Plan ID',
    type: FieldTypes.ID,
    entity: 'order',
    path: 'plan_id',
    description: 'The unique identifier of the plan subscribed by the customer for recurring payments.',
  },
  [_.PSP_AUTHENTICATION_ID]: {
    key: _.PSP_AUTHENTICATION_ID,
    label: 'PSP authentication ID',
    type: FieldTypes.ID,
    entity: 'transactions',
    path: 'psp_authentication_id',
    description: 'The identifier of the authentication of the transaction provided by the authentication partner.',
  },
  [_.PSP_RESULT_CODE]: {
    key: _.PSP_RESULT_CODE,
    label: 'PSP result code',
    type: FieldTypes.PSP_RESULT_CODE,
    entity: 'transactions',
    path: 'psp_result_code',
    filter: true,
    description: 'The status code for the transaction provided by the payin partner.',
  },
  [_.PSP_RESULT_DESCRIPTION]: {
    key: _.PSP_RESULT_DESCRIPTION,
    label: 'PSP result description',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'psp_result_description',
    filter: true,
    description: 'The status description for the transaction provided by the payin partner.',
  },
  [_.PSP_TOKEN]: {
    key: _.PSP_TOKEN,
    label: 'PSP token',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'psp_token',
    description:
      'The partner token. A token is a secured and unique identifier generated from a card number, to identify the card and obfuscate its original value.',
  },
  [_.PSP_TRANSACTION_DATE]: {
    key: _.PSP_TRANSACTION_DATE,
    label: 'PSP transaction date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'psp_transaction_date',
    filter: true,
    description: 'The creation date of the transaction by the partner.',
  },
  [_.PSP_TRANSACTION_ID]: {
    key: _.PSP_TRANSACTION_ID,
    label: 'PSP transaction ID',
    type: FieldTypes.ID,
    entity: 'transactions',
    path: 'psp_transaction_id',
    filter: true,
    description: 'The identifier of the transaction provided by the payin partner.',
  },
  [_.RECURRING]: {
    key: _.RECURRING,
    label: 'Recurring',
    type: FieldTypes.BOOLEAN,
    entity: 'transactions',
    path: 'recurring',
    description: 'Indicates if the transaction is a recurring payment',
  },
  [_.REFUNDED_AMOUNT]: {
    key: _.REFUNDED_AMOUNT,
    label: 'Refunded amount',
    type: FieldTypes.AMOUNT,
    entity: 'transactions',
    path: 'refunded_amount',
    description: 'The total amount refunded for the transaction.',
  },
  [_.REFUND_DATE]: {
    key: _.REFUND_DATE,
    label: 'Refund date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'refund_date',
    filter: true,
    description: 'The refund date of the transaction.',
  },
  [_.REFUND_REASON]: {
    key: _.REFUND_REASON,
    label: 'Refund reason',
    type: FieldTypes.REFUND_REASON,
    entity: 'transactions',
    path: 'refund_reason',
    filter: true,
    description: 'The reason for the refund. It can be Product not available, Requested by customer, Fraudulent, Duplicate, Other.',
  },
  [_.REFUND_REQUEST_DATE]: {
    key: _.REFUND_REQUEST_DATE,
    label: 'Refund request date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'refund_request_date',
    description: 'The date of the request for refund of the transaction.',
  },
  [_.REFUND_STATUS]: {
    key: _.REFUND_STATUS,
    label: 'Refund status',
    type: FieldTypes.REFUND_STATUS,
    entity: 'transactions',
    path: 'refund_status',
    description: 'The refund status of the transaction. It can be Refund requested, Refund successful, Refund declined.',
  },
  [_.RISK_ASSESSMENT_DATE]: {
    key: _.RISK_ASSESSMENT_DATE,
    label: 'Risk assessment date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'risk_assessment_date',
    description: 'The risk assessment date of the transaction.',
  },
  [_.RISK_ASSESSMENT_DEVICE_FINGERPRINT]: {
    key: _.RISK_ASSESSMENT_DEVICE_FINGERPRINT,
    label: 'Risk assessment device fingerprint',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'risk_assessment_device_fingerprint',
    gdpr: true,
    description: 'The customer’s device fingerprint calculated by the Risk assessment provider.',
  },
  [_.RISK_ASSESSMENT_PARTNER]: {
    key: _.RISK_ASSESSMENT_PARTNER,
    label: 'Risk assessment partner',
    type: FieldTypes.RISK_ASSESSMENT_PARTNER,
    entity: 'order',
    path: 'transactions.risk_assessment_partner_api_name',
    filter: true,
    description: 'The provider who handled the risk assessment of the transaction.',
  },
  [_.RISK_ASSESSMENT_REASON]: {
    key: _.RISK_ASSESSMENT_REASON,
    label: 'Risk assessment reason',
    type: FieldTypes.RISK_ASSESSMENT_REASON,
    entity: 'transactions',
    path: 'risk_assessment_reason',
    description: 'The reason attached to the result of the risk assessment of the transaction.',
  },
  [_.RISK_ASSESSMENT_REASON_CODE]: {
    key: _.RISK_ASSESSMENT_REASON_CODE,
    label: 'Risk assessment reason code',
    type: FieldTypes.RISK_ASSESSMENT_REASON_CODE,
    entity: 'transactions',
    path: 'risk_assessment_reason_code',
    description: 'The reason code attached to the result of the risk assessment of the transaction.',
  },
  [_.RISK_ASSESSMENT_RESULT]: {
    key: _.RISK_ASSESSMENT_RESULT,
    label: 'Risk assessment result',
    type: FieldTypes.STATUS_RESULT,
    entity: 'transactions',
    path: 'risk_assessment_result',
    filter: true,
    description: 'The result of the risk assessment of the transaction by the risk assessment provider.',
  },
  [_.RISK_ASSESSMENT_SCORE]: {
    key: _.RISK_ASSESSMENT_SCORE,
    label: 'Risk assessment score',
    type: FieldTypes.NUMBER,
    entity: 'transactions',
    path: 'risk_assessment_score',
    description: 'The score calculated by the risk assessment partner.',
  },
  [_.SCA_EXEMPTION_REASON]: {
    key: _.SCA_EXEMPTION_REASON,
    label: 'SCA exemption reason',
    type: FieldTypes.SCA_EXEMPTION_REASON,
    entity: 'transactions',
    path: 'sca_exemption_reason',
    filter: true,
    description: 'The SCA (Strong Customer Authentication) exemption reason. It indicates the reason why the order should be exempted from 3DSecure.',
  },
  [_.SCHEDULED_CAPTURE_DATE]: {
    key: _.SCHEDULED_CAPTURE_DATE,
    label: 'Scheduled capture date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'scheduled_capture_date',
    filter: true,
    description: 'The scheduled capture date of the transaction.',
  },
  [_.SCHEME_AUTHENTICATION_ID]: {
    key: _.SCHEME_AUTHENTICATION_ID,
    label: 'Scheme authentication ID',
    type: FieldTypes.ID,
    entity: 'transactions',
    path: 'scheme_authentication_id',
    description: 'The identifier of the authentication provided by the scheme.',
  },
  [_.SCHEME_CUSTOMER]: {
    key: _.SCHEME_CUSTOMER,
    label: 'Scheme customer',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'token.customer_scheme_name',
    description: 'The name of the card scheme selected by the customer during the payment process.',
  },
  [_.SCHEME_REAL]: {
    key: _.SCHEME_REAL,
    label: 'Scheme real',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'token.real_scheme',
    description:
      'The name of the card scheme identified for the payment transaction. When available, it may be different from the customer_scheme_name. For instance, for a payment with a card Carte Bancaire, the real scheme may be Visa.',
  },
  [_.SCHEME_SECONDARY]: {
    key: _.SCHEME_SECONDARY,
    label: 'Scheme secondary',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'token.secondary_scheme',
    description:
      'The name of the secondary scheme of the card used by the customer for the payment. For instance Visa and Carte Bancaire where CB is the secondary scheme.',
  },
  [_.SHIPPING_ADDRESS_CITY]: {
    key: _.SHIPPING_ADDRESS_CITY,
    label: 'Shipping address city',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'shipping_address_city',
    description: 'The city on the shipping address.',
  },
  [_.SHIPPING_ADDRESS_COUNTRY]: {
    key: _.SHIPPING_ADDRESS_COUNTRY,
    label: 'Shipping address country',
    type: FieldTypes.COUNTRY,
    entity: 'order',
    path: 'shipping_address_country',
    description: "The customer's country on the shipping address. In text mode, it uses the 2-letter ISO country code.",
  },
  [_.SHIPPING_ADDRESS_FIRST_USE_DATE]: {
    key: _.SHIPPING_ADDRESS_FIRST_USE_DATE,
    label: 'Shipping address first use date',
    type: FieldTypes.DATE,
    entity: 'order',
    path: 'shipping_address_first_use_date',
    description: 'The date of the first use of the shipping address.',
  },
  [_.SHIPPING_ADDRESS_STREET_NAME_LINE1]: {
    key: _.SHIPPING_ADDRESS_STREET_NAME_LINE1,
    label: 'Shipping address street name line 1',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'shipping_address_street_name_line1',
    gdpr: true,
    description: 'The first line of the street on the shipping address.',
  },
  [_.SHIPPING_ADDRESS_STREET_NAME_LINE2]: {
    key: _.SHIPPING_ADDRESS_STREET_NAME_LINE2,
    label: 'Shipping address street name line 2',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'shipping_address_street_name_line2',
    gdpr: true,
    description: 'The second line of the street on the shipping address.',
  },
  [_.SHIPPING_ADDRESS_ZIP_CODE]: {
    key: _.SHIPPING_ADDRESS_ZIP_CODE,
    label: 'Shipping address zip code',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'shipping_address_zip_code',
    gdpr: true,
    description: 'The ZIP code on the shipping address.',
  },
  [_.SHIPPING_CARRIER_NAME]: {
    key: _.SHIPPING_CARRIER_NAME,
    label: 'Shipping carrier name',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'shipping_carrier_name',
    description: 'The name of the carrier in charge of the shipping.',
  },
  [_.SHIPPING_DELIVERY_METHOD]: {
    key: _.SHIPPING_DELIVERY_METHOD,
    label: 'Shipping delivery method',
    type: FieldTypes.SHIPPING_DELIVERY_METHOD,
    entity: 'order',
    path: 'shipping_delivery_method',
    description: 'The shipping delivery method.',
  },
  [_.SHIPPING_DELIVERY_RANGE]: {
    key: _.SHIPPING_DELIVERY_RANGE,
    label: 'Shipping delivery range',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'shipping_delivery_range',
    description: 'The shipping delivery range.',
  },
  [_.SHIPPING_FIRST_NAME]: {
    key: _.SHIPPING_FIRST_NAME,
    label: 'Shipping first name',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'shipping_first_name',
    gdpr: true,
    description: 'The first name registered for the shipping.',
  },
  [_.SHIPPING_ID]: {
    key: _.SHIPPING_ID,
    label: 'Shipping ID',
    type: FieldTypes.ID,
    entity: 'order',
    path: 'shipping_id',
    description: 'The identifier of the shipping.',
  },
  [_.SHIPPING_LAST_NAME]: {
    key: _.SHIPPING_LAST_NAME,
    label: 'Shipping last name',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'shipping_last_name',
    gdpr: true,
    description: 'The last name registered for the shipping.',
  },
  [_.SHIPPING_PHONE_NUMBER]: {
    key: _.SHIPPING_PHONE_NUMBER,
    label: 'Shipping phone number',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'shipping_phone_number',
    gdpr: true,
    description: 'The phone number registered for the shipping.',
  },
  [_.SHIPPING_PRICE]: {
    key: _.SHIPPING_PRICE,
    label: 'Shipping price',
    type: FieldTypes.AMOUNT,
    entity: 'order',
    path: 'shipping_price',
    description: 'The shipping price.',
  },
  [_.SHIPPING_TAX]: {
    key: _.SHIPPING_TAX,
    label: 'Shipping tax',
    type: FieldTypes.AMOUNT,
    entity: 'order',
    path: 'shipping_tax',
    description: 'The tax amount included in the shipping price.',
  },
  [_.SHIPPING_TAX_RATE]: {
    key: _.SHIPPING_TAX_RATE,
    label: 'Shipping tax rate',
    type: FieldTypes.NUMBER,
    entity: 'order',
    path: 'shipping_tax_rate',
    description: 'The tax rate applied on the shipping.',
  },
  [_.SOURCE]: {
    key: _.SOURCE,
    label: 'Source',
    type: FieldTypes.SOURCE,
    entity: 'order',
    path: 'source',
    filter: true,
    description: 'The source of the order (stack / insights).',
  },
  [_.TRANSACTION_STATUS]: {
    key: _.TRANSACTION_STATUS,
    label: 'Transaction status',
    type: FieldTypes.STATUS,
    entity: 'transactions',
    path: 'status',
    filter: true,
    description: 'The current status of the transaction. On the order view, it refers to the status of the last transaction of the order.',
  },
  [_.SUBSCRIBER_ID]: {
    key: _.SUBSCRIBER_ID,
    label: 'Subscriber ID',
    type: FieldTypes.ID,
    entity: 'order',
    path: 'subscriber_id',
    description: 'The identifier of the subscriber in case of recurring payments.',
  },
  [_.SUBSCRIPTION_COUNT]: {
    key: _.SUBSCRIPTION_COUNT,
    label: 'Subscription count',
    type: FieldTypes.NUMBER,
    entity: 'order',
    path: 'subscription_count',
    description: 'The rank in the installment plan in case of recurring payments.',
  },
  [_.SUBSCRIPTION_DESCRIPTION]: {
    key: _.SUBSCRIPTION_DESCRIPTION,
    label: 'Subscription description',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'subscription_description',
    description: 'The description of the subscription in case of recurring payments.',
  },
  [_.SUBSCRIPTION_END_DATE]: {
    key: _.SUBSCRIPTION_END_DATE,
    label: 'Subscription end date',
    type: FieldTypes.DATE,
    entity: 'order',
    path: 'subscription_end_date',
    description: 'The end date of the subscription in case of recurring payments.',
  },
  [_.SUBSCRIPTION_ID]: {
    key: _.SUBSCRIPTION_ID,
    label: 'Subscription ID',
    type: FieldTypes.ID,
    entity: 'order',
    path: 'subscription_id',
    description: 'The identifier of the subscription in case of recurring payments.',
  },
  [_.SUBSCRIPTION_RECURRENCE]: {
    key: _.SUBSCRIPTION_RECURRENCE,
    label: 'Subscription recurrence',
    type: FieldTypes.NUMBER,
    entity: 'order',
    path: 'subscription_recurrence',
    description: 'The frequency of the subscription in case of recurring payments.',
  },
  [_.TOKEN]: {
    key: _.TOKEN,
    label: 'Token',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'token.norbr',
    filter: true,
    description: 'The token is a secured and unique identifier generated from a card number, to identify the card and obfuscate its original value.',
  },
  [_.TRANSACTION_ID]: {
    key: _.TRANSACTION_ID,
    label: 'Transaction ID',
    type: FieldTypes.ID,
    entity: 'transactions',
    path: 'id',
    filter: true,
    description: 'The unique identifier of the transaction.',
  },
  [_.TRANSACTION_UPDATE_DATE]: {
    key: _.TRANSACTION_UPDATE_DATE,
    label: 'Transaction update date',
    type: FieldTypes.DATE,
    entity: 'transactions',
    path: 'updatedAt',
    filter: true,
    description: 'The last update date of the transaction.',
  },
  [_.ORDER_TRANSACTIONS_COUNT]: {
    key: _.ORDER_TRANSACTIONS_COUNT,
    label: 'Transactions count',
    type: FieldTypes.COUNT,
    entity: 'order',
    path: 'transaction_count',
    filter: true,
    description: 'The count of transactions on the order.',
  },
  [_.TYPE]: {
    key: _.TYPE,
    label: 'Transaction type',
    type: FieldTypes.TYPE,
    entity: 'transactions',
    path: 'type',
    description: 'Indicates if the payment transaction is a direct capture or authorization type',
  },
  [_.UPDATE_DATE]: {
    key: _.UPDATE_DATE,
    label: 'Order update date',
    type: FieldTypes.DATE,
    entity: 'order',
    path: 'updatedAt',
    description: 'The last update date of the order',
  },
  [_.WEBSITE_URL]: {
    key: _.WEBSITE_URL,
    label: 'Website url',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'website_url',
    description: 'The URL of the merchant website initiating the order process.',
  },
  [_.CUSTOMER_BILLING_STATE]: {
    key: _.CUSTOMER_BILLING_STATE,
    label: 'Customer billing state',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_billing_state',
    description: 'The state on the billing address.',
  },
  [_.CUSTOMER_STATE]: {
    key: _.CUSTOMER_STATE,
    label: 'Customer state',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'customer_state',
    description: "The customer's state.",
  },
  [_.MERCHANT_STORE_ID]: {
    key: _.MERCHANT_STORE_ID,
    label: 'Merchant store ID',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'merchant_store_id',
    description: 'The identifier of the merchant store.',
    filter: true,
  },
  [_.MERCHANT_TERMINAL_ID]: {
    key: _.MERCHANT_TERMINAL_ID,
    label: 'Merchant terminal ID',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'merchant_terminal_id',
    description: 'The identifier of the merchant terminal.',
    filter: true,
  },
  [_.SHIPPING_ADDRESS_STATE]: {
    key: _.SHIPPING_ADDRESS_STATE,
    label: 'Shipping address state',
    type: FieldTypes.TEXT,
    entity: 'order',
    path: 'shipping_address_state',
    description: 'The state on the shipping address.',
  },
  [_.SHIPPING_ADDRESS_EMAIL]: {
    key: _.SHIPPING_ADDRESS_EMAIL,
    label: 'Shipping address email',
    type: FieldTypes.TEXT,
    entity: 'order',
    gdpr: true,
    path: 'shipping_address_email',
    description: 'The email address registered for the shipping.',
  },
  [_.RESULT_CODE]: {
    key: _.RESULT_CODE,
    label: 'Result code',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'norbr_result_code',
    description: "The normalized status code for the transaction based on the payin partner's response.",
  },
  [_.RESULT_DESCRIPTION]: {
    key: _.RESULT_DESCRIPTION,
    label: 'Result description',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'norbr_result_description',
    description: "The normalized status description for the transaction based on the payin partner's response.",
  },
  [_.REFUND_REQUEST_STATUS]: {
    key: _.REFUND_REQUEST_STATUS,
    label: 'Refund request status',
    type: FieldTypes.REFUND_REQUEST_STATUS,
    entity: 'transactions',
    path: 'refund_request_status',
    description: 'The result of the request for refund of the transaction. It can be Refund requested or Refund request failed.',
  },
  [_.ROUTING_MODE]: {
    key: _.ROUTING_MODE,
    label: 'Routing mode',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'routing_mode',
    description: 'The mode selected for the routing of the transaction. It can be Default Provider, Routing System, Merchant Contract.',
  },
  [_.ROUTING_RULE]: {
    key: _.ROUTING_RULE,
    label: 'Routing rule',
    type: FieldTypes.ID,
    entity: 'transactions',
    path: 'routing_response.reason.rule_id',
    filter: true,
    description: 'The rule used for the routing of the transaction.',
  },
  [_.ROUTING_RULE_VERSION]: {
    key: _.ROUTING_RULE_VERSION,
    label: 'Routing rule version',
    type: FieldTypes.TEXT,
    entity: 'transactions',
    path: 'routing_response.reason.rule_version',
    filter: true,
    description: 'The version of the rule used for the routing of the transaction.',
  },

  [_.FINANCIAL_OPERATION_ID]: {
    key: _.FINANCIAL_OPERATION_ID,
    label: 'Financial operation ID',
    type: FieldTypes.ID,
    entity: 'financial_operations',
    path: 'id',
    filter: true,
    description: 'The unique identifier of the financial operation.',
  },
  [_.FINANCIAL_OPERATION_TYPE]: {
    key: _.FINANCIAL_OPERATION_TYPE,
    label: 'Financial operation type',
    type: FieldTypes.FINANCIAL_OPERATION_TYPE,
    entity: 'financial_operations',
    path: 'financial_operation_type',
    filter: true,
    description: 'The type of the financial operation. It can be Balance, Fee or Miscellaneous.',
  },
  [_.FINANCIAL_OPERATION_FEE_TYPE]: {
    key: _.FINANCIAL_OPERATION_FEE_TYPE,
    label: 'Financial operation fee type',
    type: FieldTypes.FINANCIAL_OPERATION_FEE_TYPE,
    entity: 'financial_operations',
    path: 'fee_type',
    filter: true,
    description: 'The type of fee of the financial operation, such as PSP fee, Acquirer fee, Card scheme fee, ...',
  },
  [_.FINANCIAL_OPERATION_AMOUNT]: {
    key: _.FINANCIAL_OPERATION_AMOUNT,
    label: 'Financial operation amount',
    type: FieldTypes.AMOUNT,
    entity: 'financial_operations',
    path: 'financial_operation_amount',
    filter: true,
    description: "The  amount of a financial movement that impacts the merchant's balance.",
  },
  [_.FINANCIAL_OPERATION_CURRENCY]: {
    key: _.FINANCIAL_OPERATION_CURRENCY,
    label: 'Financial operation currency',
    type: FieldTypes.CURRENCY,
    entity: 'financial_operations',
    path: 'financial_operation_currency',
    filter: true,
    description: 'The currency used for the financial operation. It uses the 3-letter ISO currency code.',
  },
  [_.FINANCIAL_OPERATION_MOVEMENT]: {
    key: _.FINANCIAL_OPERATION_MOVEMENT,
    label: 'Movement',
    type: FieldTypes.FINANCIAL_OPERATION_MOVEMENT,
    entity: 'financial_operations',
    path: 'movement',
    filter: true,
    description: 'The movement represented by the financial operation, which can be Credit or Debit.',
  },
  [_.FINANCIAL_OPERATION_CREATED_AT]: {
    key: _.FINANCIAL_OPERATION_CREATED_AT,
    label: 'Financial operation creation date',
    type: FieldTypes.DATE,
    entity: 'financial_operations',
    path: 'inserted_at',
    filter: true,
    description:
      'The date of the creation of the financial operation in the platform. If a financial operation is created after collecting a file at the partner, it represents the date when data from this file is inserted into our platform.',
  },
  [_.FINANCIAL_OPERATION_PAYMENT_OPERATION_ID]: {
    key: _.FINANCIAL_OPERATION_PAYMENT_OPERATION_ID,
    label: 'Operation ID',
    type: FieldTypes.OBJECT_ID,
    entity: 'financial_operations',
    path: 'norbr_operation_id',
    filter: true,
    description: 'The unique identifier of the payment operation linked to the financial operation.',
  },
  [_.FINANCIAL_OPERATION_PAYMENT_OPERATION_TYPE]: {
    key: _.FINANCIAL_OPERATION_PAYMENT_OPERATION_TYPE,
    label: 'Operation type',
    type: FieldTypes.OPERATION_TYPE,
    entity: 'financial_operations',
    path: 'operation_type',
    filter: true,
    description: 'The type of payment operation linked to the financial operation, for example Authorization, Capture, Cancel, Refund, Chargeback.',
  },
  [_.INBOUND_BATCH_DATE]: {
    key: _.INBOUND_BATCH_DATE,
    label: 'Inbound batch date',
    type: FieldTypes.DATE,
    entity: 'financial_operations',
    path: 'batch_date',
    filter: true,
    description:
      'An inbound batch represents a group of financial operations reconciled on the same day for a partner. The inbound batch date is the date when the reconciliation process occurred.',
  },
  [_.INBOUND_BATCH_ID]: {
    key: _.INBOUND_BATCH_ID,
    label: 'Inbound batch ID',
    type: FieldTypes.ID,
    entity: 'financial_operations',
    path: 'batch_id',
    filter: true,
    description:
      'An inbound batch represents a group of financial operations reconciled on the same day for a partner. The inbound batch ID is the unique identifier of the reconciliation batch.',
  },
  [_.CARD_CATEGORY]: {
    key: _.CARD_CATEGORY,
    label: 'Card category',
    type: FieldTypes.CARD_CATEGORY,
    entity: 'transactions',
    path: 'token.type1',
    filter: true,
    description: 'The card category used for the payment. It can be Corporate or Personal.',
  },
  [_.CARD_ISSUING_COUNTRY]: {
    key: _.CARD_ISSUING_COUNTRY,
    label: 'Card issuing country',
    type: FieldTypes.COUNTRY,
    entity: 'financial_operations',
    path: 'card_issuing_country',
    filter: true,
    description:
      'The country of the issuer of the card used for the payment retrieved by the acquirer. In text mode, it appears as a 2-letter ISO country code.',
  },
  [_.CARD_TYPE]: {
    key: _.CARD_TYPE,
    label: 'Card type',
    type: FieldTypes.CARD_TYPE,
    entity: 'transactions',
    path: 'token.type2',
    filter: true,
    description: 'The card type used for the payment. It can be Credit, Debit or Prepaid.',
  },
  [_.ENVIRONMENT]: {
    key: _.ENVIRONMENT,
    label: 'Environment',
    type: FieldTypes.ENVIRONMENT,
    entity: 'financial_operations',
    path: 'environment',
    filter: true,
    description: 'The environment in which the financial operation took place, for example Sandbox or Production.',
  },
  [_.INTERCHANGE_ZONE]: {
    key: _.INTERCHANGE_ZONE,
    label: 'Interchange zone',
    type: FieldTypes.TEXT,
    entity: 'financial_operations',
    path: 'interchange_zone',
    description:
      'The interchange zone is based on the merchant and cardholder’s bank geographical locations. It defines the calculation of the interchange fee for payment transactions made via a card scheme (Visa, Mastercard, etc.).',
  },
  [_.MERCHANT_ACCOUNT_COUNTRY]: {
    key: _.MERCHANT_ACCOUNT_COUNTRY,
    label: 'Merchant account country',
    type: FieldTypes.COUNTRY,
    entity: 'financial_operations',
    path: 'merchant_account_country',
    filter: true,
    description: "The geographical location of the merchant's account. In text mode, it appears as a 2-letter ISO country code.",
  },
  [_.PARTNER_CARD_CATEGORY]: {
    key: _.PARTNER_CARD_CATEGORY,
    label: 'Partner card category',
    type: FieldTypes.TEXT,
    entity: 'financial_operations',
    path: 'partner_card_type_1',
    filter: true,
    description: 'The card category used for the payment retrieved by the acquirer.',
  },
  [_.PARTNER_CARD_TYPE]: {
    key: _.PARTNER_CARD_TYPE,
    label: 'Partner card type',
    type: FieldTypes.TEXT,
    entity: 'financial_operations',
    path: 'partner_card_type_2',
    filter: true,
    description: 'The card type used for the payment retrieved by the acquirer.',
  },
  [_.PARTNER_OPERATION_ID]: {
    key: _.PARTNER_OPERATION_ID,
    label: 'Partner operation ID',
    type: FieldTypes.ID,
    entity: 'financial_operations',
    path: 'partner_operation_id',
    filter: true,
    description: 'The identifier of the payment operation provided by the partner.',
  },
  [_.PARTNER_OPERATION_DATE]: {
    key: _.PARTNER_OPERATION_DATE,
    label: 'Partner operation date',
    type: FieldTypes.DATE,
    entity: 'financial_operations',
    path: 'partner_operation_date',
    filter: true,
    description: 'The creation date by the partner of the payment operation linked to the financial operation.',
  },
  [_.PARTNER_OPERATION_STATUS]: {
    key: _.PARTNER_OPERATION_STATUS,
    label: 'Partner operation status',
    type: FieldTypes.STATUS,
    entity: 'financial_operations',
    path: 'partner_operation_status',
    filter: true,
    description: 'The status of the payment operation (linked to the financial operation) provided by the partner.',
  },
  [_.PARTNER_TYPE]: {
    key: _.PARTNER_TYPE,
    label: 'Partner type',
    type: FieldTypes.PARTNER_TYPE,
    entity: 'financial_operations',
    path: 'partner_type',
    filter: true,
    description: 'The type of service provider handled the payment operation (Authentication, Payin, ...).',
  },
  [_.RECONCILIATION_FILE_NAME]: {
    key: _.RECONCILIATION_FILE_NAME,
    label: 'Reconciliation file name',
    type: FieldTypes.ID,
    entity: 'financial_operations',
    path: 'reconciliation_file_name',
    filter: true,
    description: 'The name of the reconciliation file provided by the partner processed to create the financial operations.',
  },
  [_.SETTLEMENT_ID]: {
    key: _.SETTLEMENT_ID,
    label: 'Settlement ID',
    type: FieldTypes.ID,
    entity: 'financial_operations',
    path: 'settlement_id',
    filter: true,
    description: 'The identifier provided by the partner for the settlement.',
  },
  [_.SETTLEMENT_DATE]: {
    key: _.SETTLEMENT_DATE,
    label: 'Settlement date',
    type: FieldTypes.DATE,
    entity: 'financial_operations',
    path: 'settlement_date',
    filter: true,
    description: 'The date of the settlement provided by the partner.',
  },
  [_.PARTNER_INVOICE_NUMBER]: {
    key: _.PARTNER_INVOICE_NUMBER,
    label: 'Partner invoice number',
    type: FieldTypes.ID,
    entity: 'financial_operations',
    path: 'partner_invoice_number',
    filter: true,
    description: 'The identifier of the invoice provided by the partner.',
  },
  [_.ORDER_CREATION_DATE]: {
    key: _.ORDER_CREATION_DATE,
    label: 'Order creation date',
    type: FieldTypes.DATE,
    entity: 'order',
    path: 'createdAt',
    filter: true,
    description: 'The creation date of the order.',
  },
  [_.ORDER_IS_RECONCILED]: {
    key: _.ORDER_IS_RECONCILED,
    label: 'Order matched',
    type: FieldTypes.BOOLEAN,
    entity: 'order',
    path: 'is_reconciled',
    filter: true,
    description: 'Indicates if the order is matched.',
  },
  [_.ORDER_RECONCILED_AMOUNT]: {
    key: _.ORDER_RECONCILED_AMOUNT,
    label: 'Order matched amount',
    type: FieldTypes.AMOUNT,
    entity: 'order',
    path: 'reconciled_amount',
    filter: true,
    description: 'The matched amount of the order.',
  },
  [_.ORDER_UNRECONCILED_AMOUNT]: {
    key: _.ORDER_UNRECONCILED_AMOUNT,
    label: 'Order unmatched amount',
    type: FieldTypes.AMOUNT,
    entity: 'order',
    path: 'unreconciled_amount',
    filter: true,
    description: 'The unmatched amount of the order.',
  },
  [_.ORDER_RECONCILED_BALANCE]: {
    key: _.ORDER_RECONCILED_BALANCE,
    label: 'Order matched balance',
    type: FieldTypes.AMOUNT,
    entity: 'order',
    path: 'reconciled_balance',
    filter: true,
    description: 'The matched balance of the order.',
  },
  [_.ORDER_UNRECONCILED_BALANCE]: {
    key: _.ORDER_UNRECONCILED_BALANCE,
    label: 'Order unmatched balance',
    type: FieldTypes.AMOUNT,
    entity: 'order',
    path: 'unreconciled_balance',
    filter: true,
    description: 'The unmatched balance of the order.',
  },
  [_.ORDER_TOTAL_BALANCE]: {
    key: _.ORDER_TOTAL_BALANCE,
    label: 'Order balance',
    type: FieldTypes.AMOUNT,
    entity: 'order',
    path: 'total_balance',
    filter: true,
    description: 'The balance of the order.',
  },
  [_.TRANSACTION_IS_RECONCILED]: {
    key: _.TRANSACTION_IS_RECONCILED,
    label: 'Transaction matched',
    type: FieldTypes.BOOLEAN,
    entity: 'transactions',
    path: 'is_reconciled',
    filter: true,
    description: 'Indicates if the transaction is matched.',
  },
  [_.TRANSACTION_RECONCILED_AMOUNT]: {
    key: _.TRANSACTION_RECONCILED_AMOUNT,
    label: 'Transaction matched amount',
    type: FieldTypes.AMOUNT,
    entity: 'transactions',
    path: 'reconciled_amount',
    filter: true,
    description: 'The matched amount of the transaction.',
  },
  [_.TRANSACTION_UNRECONCILED_AMOUNT]: {
    key: _.TRANSACTION_UNRECONCILED_AMOUNT,
    label: 'Transaction unmatched amount',
    type: FieldTypes.AMOUNT,
    entity: 'transactions',
    path: 'unreconciled_amount',
    filter: true,
    description: 'The unmatched amount of the transaction.',
  },
  [_.TRANSACTION_RECONCILED_BALANCE]: {
    key: _.TRANSACTION_RECONCILED_BALANCE,
    label: 'Transaction matched balance',
    type: FieldTypes.AMOUNT,
    entity: 'transactions',
    path: 'reconciled_balance',
    filter: true,
    description: 'The matched balance of the transaction.',
  },
  [_.TRANSACTION_UNRECONCILED_BALANCE]: {
    key: _.TRANSACTION_UNRECONCILED_BALANCE,
    label: 'Transaction unmatched balance',
    type: FieldTypes.AMOUNT,
    entity: 'transactions',
    path: 'unreconciled_balance',
    filter: true,
    description: 'The unmatched balance of the transaction.',
  },
  [_.TRANSACTION_TOTAL_BALANCE]: {
    key: _.TRANSACTION_TOTAL_BALANCE,
    label: 'Transaction balance',
    type: FieldTypes.AMOUNT,
    entity: 'transactions',
    path: 'total_balance',
    filter: true,
    description: 'The balance of the transaction.',
  },
  [_.OPERATION_IS_RECONCILED]: {
    key: _.OPERATION_IS_RECONCILED,
    label: 'Matched',
    type: FieldTypes.BOOLEAN,
    entity: 'operation',
    path: 'is_reconciled',
    filter: true,
    description: 'Indicates if the operation is matched.',
  },
  [_.OPERATION_RECONCILED_AMOUNT]: {
    key: _.OPERATION_RECONCILED_AMOUNT,
    label: 'Matched amount',
    type: FieldTypes.AMOUNT,
    entity: 'operation',
    path: 'reconciled_amount',
    filter: true,
    description: 'The matched amount of the operation.',
  },
  [_.OPERATION_UNRECONCILED_AMOUNT]: {
    key: _.OPERATION_UNRECONCILED_AMOUNT,
    label: 'Unmatched amount',
    type: FieldTypes.AMOUNT,
    entity: 'operation',
    path: 'unreconciled_amount',
    filter: true,
    description: 'The unmatched amount of the operation.',
  },
  [_.RECONCILIATION_REASON]: {
    key: _.RECONCILIATION_REASON,
    label: 'Match reason',
    type: FieldTypes.RECONCILIATION_REASON,
    entity: 'operation',
    path: 'reconciliation_information.reconciliation_reason',
    filter: true,
    description: 'The assumed reason why the automatic match failed. It was emitted by the author of the manual match.',
  },
  [_.WITHDRAW_REASON]: {
    key: _.WITHDRAW_REASON,
    label: 'Withdraw reason',
    type: FieldTypes.WITHDRAW_REASON,
    entity: 'operation',
    path: 'reconciliation_information.withdraw_reason',
    filter: true,
    description: 'The assumed reason why the transaction was withdrawn. It was emitted by the author of the withdraw.',
  },
  [_.RECONCILIATION_NOTE]: {
    key: _.RECONCILIATION_NOTE,
    label: 'Match note',
    type: FieldTypes.TEXT,
    entity: 'operation',
    path: 'reconciliation_information.note',
    description: 'The note wrote by the author of the manual match.',
  },
  [_.RECONCILIATION_AUTHOR_EMAIL]: {
    key: _.RECONCILIATION_AUTHOR_EMAIL,
    label: 'Match author email',
    type: FieldTypes.TEXT,
    entity: 'operation',
    path: 'reconciliation_information.author_email',
    filter: true,
    description: 'The author of the manual match.',
    gdpr: true,
  },
  [_.RECONCILIATION_DATE]: {
    key: _.RECONCILIATION_DATE,
    label: 'Match date',
    type: FieldTypes.DATE,
    entity: 'operation',
    path: 'reconciliation_date',
    filter: true,
    description: 'The date of the manual match.',
  },
  [_.RECONCILIATION_TYPE]: {
    key: _.RECONCILIATION_TYPE,
    label: 'Match type',
    type: FieldTypes.RECONCILIATION_TYPE,
    entity: 'operation',
    path: 'reconciliation_type',
    filter: true,
    description: 'The type of the match. It can be auto or manual.',
  },
  [_.PSP_OPERATION_ID]: {
    key: _.PSP_OPERATION_ID,
    label: 'Partner operation ID',
    type: FieldTypes.ID,
    entity: 'operation',
    path: 'partner_operation_id',
    filter: true,
    description: 'The identifier of the operation provided by the payin partner.',
  },
  // NOTIFICATION FIELDS
  [_.NOTIFICATION_DATE]: {
    key: _.NOTIFICATION_DATE,
    label: 'Notification date',
    type: FieldTypes.DATE,
    entity: 'notifications',
    path: 'createdAt',
    filter: true,
    description: 'The date of the notification.',
  },
  [_.NOTIFICATION_CALLS]: {
    key: _.NOTIFICATION_CALLS,
    label: 'Calls',
    type: FieldTypes.COUNT,
    entity: 'notifications',
    path: 'calls_count',
    filter: false,
    description: 'The number of calls of the notification.',
  },
  [_.NOTIFICATION_RESULT_CODE]: {
    key: _.NOTIFICATION_RESULT_CODE,
    label: 'Result',
    type: FieldTypes.TEXT,
    entity: 'notifications',
    path: 'last_call.code',
    filter: true,
    description: 'The result of the notification.',
  },
  [_.NOTIFICATION_STATUS]: {
    key: _.NOTIFICATION_STATUS,
    label: 'Status',
    type: FieldTypes.NOTIFICATION_STATUS,
    entity: 'notifications',
    path: 'status',
    filter: true,
    description: 'The status of the notification.',
  },
  [_.NOTIFICATION_TRIGGER]: {
    key: _.NOTIFICATION_TRIGGER,
    label: 'Trigger',
    type: FieldTypes.STATUS,
    entity: 'notifications',
    path: 'payload.status',
    filter: true,
    description: 'The trigger of the notification.',
  },
  [_.NOTIFICATION_ID]: {
    key: _.NOTIFICATION_ID,
    label: 'Notification ID',
    type: FieldTypes.OBJECT_ID,
    entity: 'notifications',
    path: '_id',
    filter: true,
    description: 'The ID of the notification.',
  },
  [_.NOTIFICATION_URL]: {
    key: _.NOTIFICATION_URL,
    label: 'URL',
    type: FieldTypes.TEXT,
    entity: 'notifications',
    path: 'url',
    filter: true,
    description: 'The URL of the notification.',
  },
  [_.NOTIFICATION_WEBHOOK]: {
    key: _.NOTIFICATION_WEBHOOK,
    label: 'Webhook',
    type: FieldTypes.WEBHOOK,
    entity: 'notifications',
    path: 'webhook._id',
    filter: true,
    description: 'The webhook of the notification.',
  },
  [_.NOTIFICATION_TRANSACTION_ID]: {
    key: _.NOTIFICATION_TRANSACTION_ID,
    label: 'Transaction ID',
    type: FieldTypes.ID,
    entity: 'notifications',
    path: 'payload.transaction_id',
    filter: true,
    description: 'The ID of the transaction.',
  },
  [_.NOTIFICATION_ORDER_ID]: {
    key: _.NOTIFICATION_ORDER_ID,
    label: 'Order ID',
    type: FieldTypes.ID,
    entity: 'notifications',
    path: 'payload.order_id',
    filter: true,
    description: 'The ID of the order.',
  },
  [_.NOTIFICATION_MERCHANT_ACCOUNT]: {
    key: _.NOTIFICATION_MERCHANT_ACCOUNT,
    label: 'Merchant account ID',
    type: FieldTypes.MERCHANT_ACCOUNT,
    entity: 'notifications',
    path: 'merchant_account._id',
    filter: true,
    filterLabel: 'Merchant account',
    description: 'The unique identifier of the merchant account used for the notification.',
  },
  [_.NOTIFICATION_MERCHANT_ACCOUNT_NAME]: {
    key: _.NOTIFICATION_MERCHANT_ACCOUNT_NAME,
    label: 'Merchant account name',
    type: FieldTypes.TEXT,
    entity: 'notifications',
    path: 'merchant_account.name',
    description: 'The name of the merchant account used for the notification.',
  },
  // ADMIN FIELDS
  [_.COMPANY]: {
    key: _.COMPANY,
    label: 'Company',
    type: FieldTypes.COMPANY,
    entity: 'order',
    path: 'company._id',
    filter: true,
    description: 'The company linked to the transaction.',
  },
  [_.PROGRAM_MANAGER]: {
    key: _.PROGRAM_MANAGER,
    label: 'Program manager',
    type: FieldTypes.PROGRAM_MANAGER,
    entity: 'order',
    path: 'program_manager._id',
    filter: true,
    description: 'The program manager linked to the transaction.',
  },
  [_.META_PROGRAM_MANAGER]: {
    key: _.META_PROGRAM_MANAGER,
    label: 'Meta program manager',
    type: FieldTypes.META_PROGRAM_MANAGER,
    entity: 'order',
    path: 'meta_program_manager._id',
    filter: true,
    description: 'The meta program manager linked to the transaction.',
  },
  [_.NOTIFICATION_COMPANY]: {
    key: _.NOTIFICATION_COMPANY,
    label: 'Company',
    type: FieldTypes.COMPANY,
    entity: 'notifications',
    path: 'company._id',
    filter: true,
    description: 'The company linked to the notification.',
  },
  [_.NOTIFICATION_PROGRAM_MANAGER]: {
    key: _.NOTIFICATION_PROGRAM_MANAGER,
    label: 'Program manager',
    type: FieldTypes.PROGRAM_MANAGER,
    entity: 'notifications',
    path: 'program_manager._id',
    filter: true,
    description: 'The program manager linked to the notification.',
  },
  [_.NOTIFICATION_META_PROGRAM_MANAGER]: {
    key: _.NOTIFICATION_META_PROGRAM_MANAGER,
    label: 'Meta program manager',
    type: FieldTypes.META_PROGRAM_MANAGER,
    entity: 'notifications',
    path: 'meta_program_manager._id',
    filter: true,
    description: 'The meta program manager linked to the notification.',
  },
  // LOG FIELDS
  [_.LOG_CREATED_AT]: {
    key: _.LOG_CREATED_AT,
    label: 'Log creation date',
    type: FieldTypes.DATE,
    entity: 'log',
    path: 'time',
    filter: true,
    description: 'The date of the log.',
  },
  [_.LOG_AUTHOR_EMAIL]: {
    key: _.LOG_AUTHOR_EMAIL,
    label: 'Author email',
    type: FieldTypes.TEXT,
    entity: 'log',
    path: 'author.email',
    filter: true,
    description: 'The email address of the author of the action.',
  },
  [_.LOG_AUTHOR_FULL_NAME]: {
    key: _.LOG_AUTHOR_FULL_NAME,
    label: 'Author name',
    type: FieldTypes.TEXT,
    entity: 'log',
    path: 'author.full_name',
    filter: true,
    description: 'The name of the author of the action.',
  },
  [_.LOG_ENTITY_TYPE]: {
    key: _.LOG_ENTITY_TYPE,
    label: 'Entity type',
    type: FieldTypes.LOG_ENTITY_TYPE,
    entity: 'log',
    path: 'entityType',
    filter: true,
    description: 'The type of the updated entity.',
  },
  [_.LOG_ENTITY_NAME]: {
    key: _.LOG_ENTITY_NAME,
    label: 'Entity name',
    type: FieldTypes.TEXT,
    entity: 'log',
    path: 'entityName',
    filter: true,
    description: 'The name of the entity at the time of the action.',
  },
  [_.LOG_ENTITY_ID]: {
    key: _.LOG_ENTITY_ID,
    label: 'Entity ID',
    type: FieldTypes.LOG_ENTITY_ID,
    entity: 'log',
    path: 'entityId',
    filter: true,
    description: 'The unique identifier of the updated entity.',
  },
  [_.LOG_MERCHANT_ACCOUNT_ID]: {
    key: _.LOG_MERCHANT_ACCOUNT_ID,
    label: 'Merchant account ID',
    type: FieldTypes.MERCHANT_ACCOUNT,
    entity: 'log',
    path: 'merchantAccount._id',
    filter: true,
    filterLabel: 'Merchant account',
    description: 'The unique identifier of the merchant account associated with the updated entity.',
  },
  [_.LOG_MERCHANT_ACCOUNT_NAME]: {
    key: _.LOG_MERCHANT_ACCOUNT_NAME,
    label: 'Merchant account name',
    type: FieldTypes.TEXT,
    entity: 'log',
    path: 'merchantAccount.name',
    description: 'The name of the merchant account associated with the updated entity.',
  },
  [_.LOG_UPDATE]: {
    key: _.LOG_UPDATE,
    label: 'Details',
    type: FieldTypes.LOG_UPDATE,
    entity: 'log',
    path: 'update',
    description: 'The details of the update.',
  },
  [_.LOG_IP]: {
    key: _.LOG_IP,
    label: 'IP address',
    type: FieldTypes.TEXT,
    entity: 'log',
    path: 'ip',
    filter: true,
    description: 'The IP address of the author of the action.',
  },
  [_.LOG_COMPANY]: {
    key: _.LOG_COMPANY,
    label: 'Company',
    type: FieldTypes.COMPANY,
    entity: 'log',
    path: 'company',
    filter: true,
    description: 'The company linked to the log.',
  },
  [_.LOG_PROGRAM_MANAGER]: {
    key: _.LOG_PROGRAM_MANAGER,
    label: 'Program manager',
    type: FieldTypes.PROGRAM_MANAGER,
    entity: 'log',
    path: 'programManager',
    filter: true,
    description: 'The program manager linked to the log.',
  },
  [_.LOG_META_PROGRAM_MANAGER]: {
    key: _.LOG_META_PROGRAM_MANAGER,
    label: 'Meta program manager',
    type: FieldTypes.META_PROGRAM_MANAGER,
    entity: 'log',
    path: 'metaProgramManager',
    filter: true,
    description: 'The meta program manager linked to the log.',
  },
  // Checkout fields
  [_.CHECKOUT_ID]: {
    key: _.CHECKOUT_ID,
    label: 'Checkout ID',
    type: FieldTypes.OBJECT_ID,
    entity: 'checkout',
    path: '_id',
    filter: true,
    description: 'The ID of the checkout',
  },
  [_.CHECKOUT_CREATION_DATE]: {
    key: _.CHECKOUT_CREATION_DATE,
    label: 'Checkout creation date',
    type: FieldTypes.DATE,
    entity: 'checkout',
    path: 'createdAt',
    filter: true,
    description: 'The creation date of the checkout',
  },
  [_.CHECKOUT_UPDATE_DATE]: {
    key: _.CHECKOUT_UPDATE_DATE,
    label: 'Checkout update date',
    type: FieldTypes.DATE,
    entity: 'checkout',
    path: 'updatedAt',
    filter: true,
    description: 'The last update date of the checkout',
  },
  [_.CHECKOUT_TYPE]: {
    key: _.CHECKOUT_TYPE,
    label: 'Checkout type',
    type: FieldTypes.CHECKOUT_TYPE,
    entity: 'checkout',
    path: 'type',
    filter: true,
    description: 'The type of the checkout',
  },
  [_.CHECKOUT_EXPIRATION_DATE]: {
    key: _.CHECKOUT_EXPIRATION_DATE,
    label: 'Checkout expiration date',
    type: FieldTypes.DATE,
    entity: 'checkout',
    path: 'expiration_date',
    filter: true,
    description: 'The expiration date of the checkout',
  },
  [_.CHECKOUT_CUSTOMER_EMAIL]: {
    key: _.CHECKOUT_CUSTOMER_EMAIL,
    label: 'Checkout customer email',
    type: FieldTypes.TEXT,
    entity: 'checkout',
    path: 'customer_email',
    gdpr: true,
    filter: true,
    description: 'The email of the customer',
  },
  [_.CHECKOUT_CUSTOMER_ID]: {
    key: _.CHECKOUT_CUSTOMER_ID,
    label: 'Checkout customer ID',
    type: FieldTypes.ID,
    entity: 'checkout',
    path: 'customer_id',
    filter: true,
    description: 'The id of the customer',
  },
  [_.TOKEN_TYPE]: {
    key: _.TOKEN_TYPE,
    label: 'Checkout token type',
    type: FieldTypes.TOKEN_TYPE,
    entity: 'checkout',
    path: 'token_type',
    filter: true,
    description: 'The token type of the checkout',
  },
  [_.CHECKOUT_AMOUNT]: {
    key: _.CHECKOUT_AMOUNT,
    label: 'Checkout amount',
    type: FieldTypes.AMOUNT,
    entity: 'checkout',
    path: 'amount',
    filter: true,
    description: 'The amount of the checkout.',
  },
  [_.CHECKOUT_CURRENCY]: {
    key: _.CHECKOUT_CURRENCY,
    label: 'Checkout currency',
    type: FieldTypes.CURRENCY,
    entity: 'checkout',
    path: 'currency',
    filter: true,
    description: 'The currency of the checkout.',
  },
  [_.CHECKOUT_ORDERS_COUNT]: {
    key: _.CHECKOUT_ORDERS_COUNT,
    label: 'Checkout orders count',
    type: FieldTypes.COUNT,
    entity: 'checkout',
    path: 'orders_count',
    filter: true,
    description: 'The count of orders on the checkout.',
  },
  [_.CHECKOUT_TRANSACTIONS_COUNT]: {
    key: _.CHECKOUT_TRANSACTIONS_COUNT,
    label: 'Checkout transactions count',
    type: FieldTypes.COUNT,
    entity: 'checkout',
    path: 'transactions_count',
    filter: true,
    description: 'The count of transactions on the checkout.',
  },
  // Operation fields
  [_.OPERATION_ID]: {
    key: _.OPERATION_ID,
    label: 'Operation ID',
    type: FieldTypes.OBJECT_ID,
    entity: 'operation',
    path: '_id',
    filter: true,
    description: 'The unique identifier of the payment operation.',
  },
  [_.OPERATION_TYPE]: {
    key: _.OPERATION_TYPE,
    label: 'Operation type',
    type: FieldTypes.OPERATION_TYPE,
    entity: 'operation',
    path: 'type',
    filter: true,
    description: 'The type of payment operation, for example Authorization, Capture, Cancel, Refund, Chargeback.',
  },
  [_.OPERATION_CREATION_DATE]: {
    key: _.OPERATION_CREATION_DATE,
    label: 'Operation date',
    type: FieldTypes.DATE,
    entity: 'operation',
    path: 'createdAt',
    filter: true,
    description: 'The creation date of the payment operation.',
  },
  [_.OPERATION_AMOUNT]: {
    key: _.OPERATION_AMOUNT,
    label: 'Operation amount',
    type: FieldTypes.AMOUNT,
    entity: 'operation',
    path: 'amount',
    filter: true,
    description: 'The amount of the payment operation.',
  },
  [_.OPERATION_CURRENCY]: {
    key: _.OPERATION_CURRENCY,
    label: 'Operation currency',
    type: FieldTypes.CURRENCY,
    entity: 'operation',
    path: 'currency',
    filter: true,
    description: 'The currency of the payment operation.',
  },
  [_.OPERATION_REQUEST_STATUS]: {
    key: _.OPERATION_REQUEST_STATUS,
    label: 'Operation request status',
    type: FieldTypes.REQUEST_STATUS,
    entity: 'operation',
    path: 'request_status',
    filter: true,
    description: 'The request status of the payment operation.',
  },
  [_.OPERATION_RESULT_STATUS]: {
    key: _.OPERATION_RESULT_STATUS,
    label: 'Operation result status',
    type: FieldTypes.RESULT_STATUS,
    entity: 'operation',
    path: 'result_status',
    filter: true,
    description: 'The result status of the payment operation.',
  },
  [_.OPERATION_NOTIFICATION_DATE]: {
    key: _.OPERATION_NOTIFICATION_DATE,
    label: 'Operation notification date',
    type: FieldTypes.DATE,
    entity: 'operation',
    path: 'notification_date',
    filter: true,
    description: 'The date of the notification reconciled with the operation.',
  },
};
